import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Box, Divider, Text } from "@chakra-ui/react";
import {
  disableEditingMode,
  updateField,
} from "../../redux/actions/formActions";
import FirstName from "./EditFields/FirstName";
import LastName from "./EditFields/LastName";
import Email from "./EditFields/Email";
import Phone from "./EditFields/Phone";
import Address from "./EditFields/Address";
import TextField from "./EditFields/TextField";
import Number from "./EditFields/Number";
import DropDown from "./EditFields/DropDown";
import CheckBox from "./EditFields/CheckBox";
import Url from "./EditFields/Url";
import Paragraph from "./EditFields/Paragraph";
import Rating from "./EditFields/Rating";
import SubmitButton from "./EditFields/SubmitButton";
import DragFieldSidebar from "./DragFieldSidebar";
import BackArrow from "./Icons/BackArrow";

const Sidebar = ({
  field,
  dispatchDisableEditingMode,
  dispatchUpdateField,
}) => {
  const handleOnChange = (e, key, type) => {
    if (type && type.addChoiceValue == "addChoiceValue") {
      const cloneChoies = JSON.parse(JSON.stringify(field.choices));
      if (type.dropDown == "dropDown") {
        const findFieldIndex = cloneChoies.findIndex((choice) => {
          return choice.name == e.target.name;
        });
        cloneChoies[findFieldIndex].value = e.target.value;
      } else if (type.checkBox == "checkBox") {
        const findFieldIndex = cloneChoies.findIndex((choice) => {
          return choice.id == e.target.id;
        });
        cloneChoies[findFieldIndex].name = e.target.value;
        cloneChoies[findFieldIndex].value = e.target.value;
      } else {
        const findFieldIndex = cloneChoies.findIndex((choice) => {
          return choice.id == e.target.id;
        });
        cloneChoies[findFieldIndex].checked = e.target.checked;
      }
      const updatedField = {
        ...field,
        [key]: cloneChoies,
      };
      dispatchUpdateField(updatedField);
    } else {
      let value;
      if (key == "styleClasses") {
        value = e.target.value.split(" ");
      } else if (key == "showLabel") {
        value = e.target.checked;
      } else if (key == "countryCode") {
        value = e;
      } else {
        value = e.target.value;
      }
      const updatedField = {
        ...field,
        [key]: value,
      };
      if (field.type == "submitBtn") {
        return dispatchUpdateField(updatedField, "BUTTON");
      }
      dispatchUpdateField(updatedField);
    }
  };

  const addChoice = (key, type) => {
    const lastIndex = field.choices.length - 1;
    let lastStringValue, cloneChoies;

    if (type == "dropDown") {
      lastStringValue = field.choices[lastIndex].name;
      let countValue = lastStringValue.match(/\d+/g);
      const fieldChoiceName = `choice-${parseInt(countValue) + 1}`;
      cloneChoies = JSON.parse(JSON.stringify(field.choices));
      cloneChoies.push({ name: fieldChoiceName, value: "" });
    }
    if (type == "checkBox") {
      lastStringValue = field.choices[lastIndex].id;
      let countValue = lastStringValue.match(/\d+/g);
      const fieldChoiceName = `choice-${parseInt(countValue) + 1}`;
      cloneChoies = JSON.parse(JSON.stringify(field.choices));
      cloneChoies.push({ id: fieldChoiceName, name: "", value: "" });
    }
    const updatedField = {
      ...field,
      [key]: cloneChoies,
    };
    dispatchUpdateField(updatedField);
  };
  const removeChoice = (name, key, type) => {
    const cloneChoies = JSON.parse(JSON.stringify(field.choices));
    let findField;
    if (type == "dropDown") {
      findField = cloneChoies.filter((choice) => {
        return choice.name != name;
      });
    }
    if (type == "checkBox") {
      findField = cloneChoies.filter((choice) => {
        return choice.id != name;
      });
    }
    const updatedField = {
      ...field,
      [key]: findField,
    };
    dispatchUpdateField(updatedField);
  };

  const renderEditField = () => {
    switch (field.type) {
      case "firstName": {
        return <FirstName field={field} handleOnChange={handleOnChange} />;
      }
      case "lastName": {
        return <LastName field={field} handleOnChange={handleOnChange} />;
      }
      case "email": {
        return <Email field={field} handleOnChange={handleOnChange} />;
      }
      case "phone": {
        return <Phone field={field} handleOnChange={handleOnChange} />;
      }
      case "address": {
        return <Address field={field} />;
      }
      case "textField": {
        return <TextField field={field} handleOnChange={handleOnChange} />;
      }
      case "url": {
        return <Url field={field} handleOnChange={handleOnChange} />;
      }
      case "paragraph": {
        return <Paragraph field={field} handleOnChange={handleOnChange} />;
      }
      case "number": {
        return <Number field={field} handleOnChange={handleOnChange} />;
      }
      case "dropDown": {
        return (
          <DropDown
            field={field}
            handleOnChange={handleOnChange}
            addChoice={addChoice}
            removeChoice={removeChoice}
          />
        );
      }
      case "checkBox": {
        return (
          <CheckBox
            field={field}
            handleOnChange={handleOnChange}
            addChoice={addChoice}
            removeChoice={removeChoice}
          />
        );
      }
      case "rating": {
        return <Rating field={field} handleOnChange={handleOnChange} />;
      }
      case "submitBtn": {
        return <SubmitButton field={field} handleOnChange={handleOnChange} />;
      }
    }
  };
  return (
    <>
      {!(field && field.uid) ? (
        <DragFieldSidebar />
      ) : (
        <Box
          bg="#fff"
          borderRadius="sm"
          m="16px"
          pl="20px"
          pr="20px"
          minH="622px"
          overflow="auto"
          minW="421px"
        >
          <Box
            mb="16px"
            mt="16px"
            onClick={dispatchDisableEditingMode}
            display="flex"
          >
            <BackArrow cursor="pointer" />
            <Text ml="4px" fontSize="16px" fontWeight="600" color="#12344D">
              EDIT FIELD
            </Text>
          </Box>
          <Divider />
          {renderEditField()}
        </Box>
      )}
    </>
  );
};

Sidebar.propTypes = {
  field: PropTypes.object.isRequired,
  dispatchDisableEditingMode: PropTypes.func.isRequired,
  dispatchUpdateField: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  return {
    field: state.form.focusField,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatchDisableEditingMode: bindActionCreators(
      disableEditingMode,
      dispatch
    ),
    dispatchUpdateField: bindActionCreators(updateField, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
